import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY,
  ALLOCATION_DOUBLE_BOOKINGS_URL,
} from './queryConstants'

type UseAllocationDoubleBookings = {
  doubleBookings: (values: any) => Promise<any>
  isDoubleBookingsLoading?: boolean
}

const useAllocationDoubleBookings = (): UseAllocationDoubleBookings => {
  const createFunction = async (values: any) => {
    return postJSON({
      url: `${ALLOCATION_DOUBLE_BOOKINGS_URL}/${values.id}`,
      method: 'POST',
      json: values,
      isRota: true,
    })
  }

  const { mutateAsync: createMutation, isLoading: isDoubleBookingsLoading } =
    useMutation<any, unknown, any, unknown>(
      [ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY],
      createFunction
    )

  const doubleBookings = async (values: any) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    doubleBookings,
    isDoubleBookingsLoading,
  }
}

export default useAllocationDoubleBookings
